import React from "react";
import styles from "./toggle-button-group.module.scss";
import { HalfCircleCheck } from "../../../../assets/icons";

export interface ToggleOption {
	value: string;
	label: string;
	leftIcon?: React.ReactNode;
	rightIcon?: React.ReactNode;
	customContent?: React.ReactNode;
	expandOnSelect?: boolean;
	isDisabled?: boolean;
}

export interface ToggleButtonGroupProps {
	options: ToggleOption[];
	value?: string;
	onChange: (value: string) => void;
	name: string;
	/**
	 * Display variant:
	 * - 'default': Shows selected state with orange border and checkmark
	 * - 'mobile': Shows selected state with orange border, rounded corners, and checkmark in corner
	 */
	variant?: "default" | "mobile";
	/**
	 * Layout direction
	 */
	direction?: "horizontal" | "vertical";
}

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({ options, value, onChange, name, variant = "default", direction = "horizontal" }) => {
	return (
		<div className={`${styles.toggleGroup} ${styles[direction]} ${styles[variant]}`}>
			{options.map(option => {
				const isActive = value === option.value;
				const showExpanded = isActive && option.expandOnSelect && option.customContent;
				const isDisabled = option.isDisabled ?? false;
				// const showNormalContent = !showExpanded;

				return (
					<label key={option.value} className={`${styles.toggleOption} ${isActive ? styles.active : ""} ${isDisabled ? styles.disabled : ""}`}>
						<input
							type="radio"
							name={name}
							value={option.value}
							checked={isActive}
							onChange={e => {
								if (!isDisabled) {
									onChange(e.target.value);
								}
							}}
							disabled={isDisabled}
							className={styles.radioInput}
						/>
						<div className={styles.normalContent}>
							<div className={styles.labelIconContainer}>
								{option.leftIcon && <span className={styles.leftIcon}>{option.leftIcon}</span>}
								<span className={styles.optionLabel}>{option.label}</span>
							</div>
							{option.rightIcon && !showExpanded && <span className={styles.rightIcon}>{option.rightIcon}</span>}
						</div>
						{showExpanded && <div className={styles.expandedContent}>{option.customContent}</div>}
						{isActive && !isDisabled && (
							<span className={styles.checkmark}>
								<HalfCircleCheck />
							</span>
						)}
					</label>
				);
			})}
		</div>
	);
};
